import React, { useEffect, useState } from "react";
import { CustomButton, FilterBar, TableData } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { downloadLiberacionesCommerceReportService, getLiberacionesCommerceReportService } from "../../services/report/reportService";
import { errorAlert } from "../../helpers/alerts";
import moment from "moment";
import { currencyFormatter, downloadFile } from "../../helpers/util";
import { setTitle } from "redux/slices/uiSlice";
import { getCommercesService } from "services/client/commerceService";
import { setCommerces } from "redux/slices/client/commerceSlice";
import { Box } from "@mui/material";
import Images from "assets/images";


const LiberacionesReportScreen = () => {
  const dispatch = useDispatch();
  const { hoster } = useSelector(store => store.session);
  const { commerces } = useSelector((store) => store.commerces);

  const [list, setList] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useState({})

  const columns = [
    { name: "datetime", label: "Fecha y hora", sort: ({ createdAt }) => createdAt, format: ({ createdAt }) => moment(createdAt).format('DD/MM/YYYY HH:mm:ss') },
    { name: "import", label: "Importe", sort: ({ typeReg, amount, operacionSaldo }) => ['TAE', 'PDS', 'PIN'].includes(typeReg) ? parseFloat(amount) : parseFloat(operacionSaldo), format: ({ typeReg, amount, operacionSaldo }) => currencyFormatter.format(['TAE', 'PDS', 'PIN'].includes(typeReg) ? amount : operacionSaldo) },
    { name: "commerce", label: "Comercio", format: ({ hoster }) => hoster?.username || '' },
    { name: "bag", label: "Bolsa", format: ({ bag }) => bag?.type || '' },
    { name: "reference", label: "Referencia", format: ({ referenceSaldo }) => referenceSaldo },
    { name: "user", label: "Usuario", format: ({ user }) => user?.nameUser || '' },

  ].filter(Boolean);

  useEffect(() => {
    dispatch(setTitle('Reporte de Liberaciones'));
    if (hoster) return;
    getCommercesService(undefined, true)
      .then((response) => dispatch(setCommerces(response)))
      .catch((e) => errorAlert(e))
  }, []);


  const handlerSubmit = async (data) => {
    if (hoster)
      data.commerce = hoster.id
    // if (!(data.commerce && data.date))
    //   return
    setLoading(true)
    setFilters(data)
    getLiberacionesCommerceReportService({
      ...data,
      page,
      limit
    }).then((result) => {
      setList(result.data)
      setTotal(result.total)
    }).catch((error) => errorAlert(error))
      .finally(() => setLoading(false));
  }

  const handlerDownload = async () => {
    setLoading(true)
    downloadLiberacionesCommerceReportService(filters)
      .then((data) => downloadFile(data, 'Reporte de Liberaciones.xlsx'))
      .catch((e) => errorAlert(e))
      .finally(() => setLoading(false));
  }

  const [page, setPage] = useState(0)
  const [limit, setLimit] = useState(25)
  const sortedCommerces = [...commerces].sort((a, b) => {
    const order = { 'H2H': 1, 'DISTRIBUIDOR': 2, 'MENUDEO': 3 };
    return order[a.type_commerce] - order[b.type_commerce];
  });

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        page={page}
        limit={limit}
        // showButton={true}
        validateButton={(fields) => !(fields.commerce && fields.date)}
        defaultValues={{
          date: moment().toDate(),
        }}
        // allValue={null}
        filters={[
          !hoster && {
            name: 'commerce',
            label: "Comercio",
            type: "select",
            data: sortedCommerces?.map((item) => ({ id: item._id, name: item.username })) || [],
            loading: commerces == null
          },
          {
            type: "month",
            name: "date",
            label: "Mes",
          },
        ]}
      />
      <Box mt={-5}>
        <TableData
          loading={loading}
          onChangePage={setPage}
          onChangeRowsPerPage={setLimit}
          headerButtons={[
            <CustomButton
              dark={true}
              icon={Images.icon.download}
              key="dowloadDetails"
              name={"Descargar"}
              loading={loading}
              click={handlerDownload}
            />,
          ]}
          total={total}
          dataRows={list}
          dataTitle={columns}
          formatter={(data) => columns.map(({ format }) => format(data))}
        />
      </Box>
    </>
  );
};

export default LiberacionesReportScreen;
